import { XLARGE, LARGE, MEDIUM, SMALL } from '@core-ui/breakpoint-provider';

export const buildISMContentMappedByRows = (isDesktop, ISMData) => {
  if (!ISMData || !ISMData.length) {
    return {};
  }

  const rowsBuilt = {};
  const getRow = ISMContent => {
    return isDesktop
      ? ISMContent.rowPosition?.desktop
      : ISMContent.rowPosition?.mobile;
  };
  const getSizeLength = ISMContent => {
    return isDesktop ? ISMContent.size?.desktop : ISMContent.size?.mobile;
  };

  ISMData.forEach(ISMContent => {
    const row = getRow(ISMContent);
    const sizeLength = getSizeLength(ISMContent);
    if (row) {
      rowsBuilt[row] = { ...ISMContent, sizeLength };
    }
  });
  return rowsBuilt;
};

const shouldCreateNewRow = (spacesOccupiedOnGrid, numberOfProductsInARow) =>
  spacesOccupiedOnGrid !== 0 &&
  spacesOccupiedOnGrid % numberOfProductsInARow === 0;

const addNewRow = (row, spacesOccupiedOnGrid, numberOfProductsInARow) => {
  if (shouldCreateNewRow(spacesOccupiedOnGrid, numberOfProductsInARow)) {
    row += 1;
  }
  return row;
};

const canAddISMOnRow = (ismContentMappedByRow, ignoredRowsForISM, row) =>
  ismContentMappedByRow[row] && !ignoredRowsForISM.includes(row);

export const buildProductsDataWithIsm = ({
  ISMData,
  isDesktop,
  numberOfProductsInARow,
  products,
}) => {
  const ismContentMappedByRow = buildISMContentMappedByRows(isDesktop, ISMData);
  const productsWithIsm = {
    totalRows: 0,
    objects: [],
  };
  const ignoredRowsForISM = [];

  let spacesOccupiedOnGrid = 0;
  let row = 1;

  products.forEach((product, index) => {
    row = addNewRow(row, spacesOccupiedOnGrid, numberOfProductsInARow);

    while (canAddISMOnRow(ismContentMappedByRow, ignoredRowsForISM, row)) {
      const pageMarketingComponentData = ismContentMappedByRow[row]
      const { size, sizeLength } = pageMarketingComponentData;
      productsWithIsm.objects.push({
        isISMComponent: true,
        type: 'in-sort',
        pageMarketingComponentData,
        sizes: {
          [SMALL]: size?.mobile,
          [MEDIUM]: size?.mobile,
          [LARGE]: size?.desktop,
          [XLARGE]: size?.desktop,
        },
      });
      ignoredRowsForISM.push(row);
      spacesOccupiedOnGrid += sizeLength ?? 0;

      row = addNewRow(row, spacesOccupiedOnGrid, numberOfProductsInARow);
    }

    productsWithIsm.objects.push({ ...product, productIndex: index });
    spacesOccupiedOnGrid += 1;
  });

  productsWithIsm.totalRows = row;

  return productsWithIsm;
};
